import moment from 'moment';
import connector from '../../connector/connector';
import './dashboard.css';
import React, { useEffect, useState } from 'react';
import utilities from '../../utils/utils';
import AdminHeader from '../../components/adminHeader/adminHeader';
import { useNavigate } from 'react-router-dom';
import BannerImage from '../../components/bannerImage/bannerImage';
import Footer from '../../components/footer/footer';

const Dashboard = () => {


    const navigate = useNavigate();

    if (!localStorage.getItem('adminTokenTime') || utilities.isdateOlderThan30Minutes(localStorage.getItem('adminTokenTime'))) {
        navigate('/admin');
    }


    const [dashboardData, setDashboardData] = useState([]);



    useEffect(() => {
        const fetchGradebookData = async () => {
            // get gradebook data
            let gradeData = await connector.fetchGradebookData();

            console.log('gradeData', gradeData);
            setDashboardData(gradeData.sort((a, b) => new Date(b.createdTime) - new Date(a.createdTime)));
            // setDataCopy(gradeData.sort((a, b) => new Date(b.createdTime) - new Date(a.createdTime)));
        };

        fetchGradebookData();
    }, []);


    return (
        <div className="dashboard">
            <AdminHeader></AdminHeader>
            <BannerImage text="Admin Dashboard"></BannerImage>
            {/* <h1>Welcome to the Dashboard</h1> */}

            <h2>Assessment Submissions</h2>
            {/* <div className='gradebook-disclaimer'><p>Only assessments with at least 10 answered questions are included in these results {`(${dashboardData.length} assessments)`}</p></div> */}
            <div className="dashboard-content-wrapper-one">

                <div className='time-div'>
                    <h4>Today</h4>
                    <p>{dashboardData && dashboardData.filter(val => moment(val.createdTime).isSame(moment(), "day")).length}</p>
                    <p className='time-div-percentage'>{`${utilities.calculatePercentage(dashboardData && dashboardData.filter(val => moment(val.createdTime).isSame(moment(), "day")).length, dashboardData.length)}%`}</p>
                </div>
                <div className='time-div'>
                    <h4>Past 7 days</h4>
                    <p>{dashboardData && dashboardData.filter(val => moment(val.createdTime).isBetween(
                        moment().subtract(7, "days"), // 7 days ago
                        moment(),                     // now
                        "day",                        // granularity
                        "[]")).length}</p>
                    <p className='time-div-percentage'>{`${utilities.calculatePercentage(dashboardData && dashboardData.filter(val => moment(val.createdTime).isBetween(
                        moment().subtract(7, "days"), // 7 days ago
                        moment(),                     // now
                        "day",                        // granularity
                        "[]")).length, dashboardData.length)}%`}</p>
                </div>
                <div className='time-div'>
                    <h4>
                        Past 30 days
                    </h4>
                    <p>{dashboardData && dashboardData.filter(val => moment(val.createdTime).isBetween(
                        moment().subtract(30, "days"), // 7 days ago
                        moment(),                     // now
                        "day",                        // granularity
                        "[]")).length}</p>
                    <p className='time-div-percentage'>{`${utilities.calculatePercentage(dashboardData && dashboardData.filter(val => moment(val.createdTime).isBetween(
                        moment().subtract(30, "days"), // 7 days ago
                        moment(),                     // now
                        "day",                        // granularity
                        "[]")).length, dashboardData.length)}%`}</p>
                </div>
                <div className='time-div'>
                    <h4>Past Year</h4>
                    <p>{dashboardData && dashboardData.filter(val => moment(val.createdTime).isBetween(
                        moment().subtract(1, "year"), // 7 days ago
                        moment(),                     // now
                        "day",                        // granularity
                        "[]")).length}</p>
                    <p className='time-div-percentage'>{`${utilities.calculatePercentage(dashboardData && dashboardData.filter(val => moment(val.createdTime).isBetween(
                        moment().subtract(1, "year"), // 7 days ago
                        moment(),                     // now
                        "day",                        // granularity
                        "[]")).length, dashboardData.length)}%`}</p>

                </div>
            </div>
            <h2>Score Averages</h2>
            <div className='gradebook-disclaimer'><p>Only assessments with a counted status are included in these results {`(${dashboardData.filter(val => val.fields['Weighted'] === "true").length} assessments)`}</p></div>
            <div className='dashboard-content-wrapper-one'>
                <div className='time-div'>
                    <h4>Total Score</h4>
                    <p>{dashboardData && utilities.getWeightedScores(dashboardData).averages.total.toFixed(2)}</p>
                </div>
                <div className='time-div'>
                    <h4>Policy Score</h4>
                    <p>{dashboardData && utilities.getWeightedScores(dashboardData).averages.policy.toFixed(2)}</p>
                </div>
                <div className='time-div'>
                    <h4>People Score</h4>
                    <p>{dashboardData && utilities.getWeightedScores(dashboardData).averages.people.toFixed(2)}</p>
                </div>
                <div className='time-div'>
                    <h4>Technology Score</h4>
                    <p>{dashboardData && utilities.getWeightedScores(dashboardData).averages.technology.toFixed(2)}</p>
                </div>
            </div>
            <h2>Browser Information</h2>
            <div className='gradebook-disclaimer'><p>Only assessments with a counted status are included in these results {`(${dashboardData.filter(val => val.fields['Weighted'] === "true").length} assessments)`}</p></div>
            <div className='dashboard-content-wrapper-one'>
                <div className='time-div'>
                    <h4>Chrome</h4>
                    <p>{dashboardData && utilities.calculatePercentage( dashboardData.filter((val) => {
                        return val.fields['Browser'] === 'Chrome' && val.fields['Weighted'] === 'true';
                    }).length, dashboardData.filter(val => val.fields['Weighted'] === 'true').length)}%</p>
                </div>
                <div className='time-div'>
                    <h4>Safari</h4>
                    <p>{dashboardData && utilities.calculatePercentage( dashboardData.filter((val) => {
                        return val.fields['Browser'] === 'Safari' && val.fields['Weighted'] === 'true';
                    }).length, dashboardData.filter(val => val.fields['Weighted'] === 'true').length)}%</p>
                </div>
                <div className='time-div'>
                    <h4>Firefox</h4>
                    <p>{dashboardData && utilities.calculatePercentage( dashboardData.filter((val) => {
                        return val.fields['Browser'] === 'Firefox' && val.fields['Weighted'] === 'true';
                    }).length, dashboardData.filter(val => val.fields['Weighted'] === 'true').length)}%</p>
                </div>
                <div className='time-div'>
                    <h4>Microsoft Edge</h4>
                    <p>{dashboardData && utilities.calculatePercentage( dashboardData.filter((val) => {
                        return val.fields['Browser'] === 'Internet Explorer' && val.fields['Weighted'] === 'true';
                    }).length, dashboardData.filter(val => val.fields['Weighted'] === 'true').length)}%</p>
                </div>
               
            </div>
             <h2>Device Type</h2>
                <div className='gradebook-disclaimer'><p>Only assessments with a counted status are included in these results {`(${dashboardData.filter(val => val.fields['Weighted'] === "true").length} assessments)`}</p></div>
            <div className='dashboard-content-wrapper-one'>
                <div className='time-div'>
                    <h4>Desktop</h4>
                    <p>{dashboardData && utilities.calculatePercentage( dashboardData.filter((val) => {
                        return val.fields['Device Type'] === 'Desktop' && val.fields['Weighted'] === 'true';
                    }).length, dashboardData.filter(val => val.fields['Weighted'] === 'true').length)}%</p>
                </div>
                <div className='time-div'>
                    <h4>Mobile</h4>
                    <p>{dashboardData && utilities.calculatePercentage( dashboardData.filter((val) => {
                        return val.fields['Device Type'] === 'Mobile' && val.fields['Weighted'] === 'true';
                    }).length, dashboardData.filter(val => val.fields['Weighted'] === 'true').length)}%</p>
                </div>
                <div className='time-div'>
                    <h4>Tablet</h4>
                    <p>{dashboardData && utilities.calculatePercentage( dashboardData.filter((val) => {
                        return val.fields['Device Type'] === 'Tablet' && val.fields['Weighted'] === 'true';
                    }).length, dashboardData.filter(val => val.fields['Weighted'] === 'true').length)}%</p>
                </div>
            </div>
            <Footer></Footer>
        </div>
    );
};

export default Dashboard;